/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState } from 'react'
import AddAndRemoveSection from '../../AddAndRemoveSection';
import GlobalContext from '../../Context/GloablContext';
import { CognitoData } from '../../../CommonMethods/CognitoData';
import { dataService } from '../../../services/data.services';
import { useNavigate } from 'react-router-dom';
import { ConvertToTitleCase } from '../../../CommonMethods/ConvertToTitleCase';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';

export default function AddClass({type}) {
    const createBlankRow = () => ({
        ...(type === 'subjects' ? { name: '', description: '', is_optional : false } : { name: '', description: '' }),
        _rowId: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    });
    const [newClassFields, setNewClassFields] = useState([createBlankRow()]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [existingName, setExistingName] = useState([])
    const {setToastmessage} = useContext(GlobalContext);
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [insertType, setInsertType] = useState('END');
    const [afterItemId, setAfterItemId] = useState('');
    const [existingItems, setExistingItems] = useState([]);
    const supportsOrderedInsert = type === 'classes' || type === 'sections';
    const [existingItemsLoading, setExistingItemsLoading] = useState(supportsOrderedInsert);

    const getInsertConfig = () => {
        if (type === 'classes') {
            return { endpoint: 'classes', afterKey: 'afterClassId' };
        }
        if (type === 'sections') {
            return { endpoint: 'sections', afterKey: 'afterSectionId' };
        }
        return null;
    };

    useEffect(() => {
        let mounted = true;

        const loadExistingItems = async () => {
            const insertConfig = getInsertConfig();
            if (!insertConfig) return;
            if (mounted) setExistingItemsLoading(true);

            try {
                const branchId = await GetBranchId();
                const response = await dataService.GetAPI(
                    `${insertConfig.endpoint}?branch_id=${branchId}&filter=true&status=true`
                );
                const itemList = response?.data?.data?.data || [];
                const sortedItems = [...itemList].sort(
                    (a, b) => Number(a?.display_order || 0) - Number(b?.display_order || 0)
                );

                if (!mounted) return;
                setExistingItems(sortedItems);
                setExistingItemsLoading(false);
                if (sortedItems.length === 0) {
                    setInsertType('END');
                    setAfterItemId('');
                    return;
                }
                const defaultAfterItemId = sortedItems[sortedItems.length - 1]?._id || '';
                setAfterItemId((prev) => prev || defaultAfterItemId);
            } catch (error) {
                if (!mounted) return;
                setExistingItems([]);
                setExistingItemsLoading(false);
            }
        };

        loadExistingItems();

        return () => {
            mounted = false;
        };
    }, [type]);

    useEffect(() => {
        if (!supportsOrderedInsert) return;
        if (insertType !== 'AFTER') return;
        if (existingItems.length === 0) {
            setAfterItemId('');
            return;
        }
        const hasSelectedItem = existingItems.some((item) => item?._id === afterItemId);
        if (!hasSelectedItem) {
            setAfterItemId(existingItems[existingItems.length - 1]?._id || '');
        }
    }, [supportsOrderedInsert, insertType, existingItems, afterItemId]);

    const handleNavigation=()=>{
        if(type==='classes'){
            return '/main-hub/classes'
        }
        if(type==='sections'){
            return '/main-hub/manage-sections'
        }
        if(type==='subjects'){
            return '/main-hub/subjects'
        }   
        if(type==='fee head'){
            return '/fee-management/fee-head'
        }
        if(type==='exam'){
            return '/student-master/exam'
        }
        
    }
    const handleEndpoint=()=>{
        if(type==='exam'){
            return 'exams'
        }
        return type.replace(/\s/g,'')
    }
    const handleAdd = async (insertOptions = {}) => {
        setLoading(true);
        try {
            let response = null
            const localData = JSON.parse(localStorage.getItem('branch_details'));
            const user = await CognitoData();
            // Create a new array with trimmed names
            const rowsToSubmit = insertOptions.items || newClassFields;
            const trimmedData = rowsToSubmit.map(function(item) {
                if(type==='subjects') {
                    return {
                        name: item.name.trim(),
                        description: item.description,
                        is_optional : item.is_optional
                    };
                } else {
                    return {
                        name: item.name.trim(),
                        description: item.description
                    };
                }
                
            });
            const body = {
                "items" : trimmedData,
                branch_id : user.idToken.payload["custom:user_type"] === "institution-user" || user.idToken.payload["custom:user_type"] === "institution-admin" ? localData.id : user.idToken.payload["custom:branch_id"]
            }
            if (supportsOrderedInsert) {
                const insertConfig = getInsertConfig();
                body.insertType = insertOptions.insertType || 'END';
                if (insertOptions.insertType === 'AFTER' && insertOptions.afterItemId && insertConfig?.afterKey) {
                    body[insertConfig.afterKey] = insertOptions.afterItemId;
                }
            }
            response = await dataService.PostAPI(body, handleEndpoint());
            setToastmessage(response?.data.data?.message);
            navigate(`${handleNavigation()}`)
        } catch (error) {
            setLoading(false);
            setExistingName(error?.response?.data?.exist_list)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
        // }
    }
    const handleName=()=>{
        if(type==='classes'){
            return 'Class'
        }
        if(type==='sections'){
            return 'Section'
        }
        if(type==='subjects'){
            return 'subject'
        }
        if(type==='fee head'){
            return 'Fee Head'
        }
        if(type==='exam'){
            return 'Exam'

        }

    }
    return (
        <>
            <AddAndRemoveSection 
                handleNavigation={handleNavigation}
                newClassFields={newClassFields}
                setNewClassFields={setNewClassFields}
                Tittle={ConvertToTitleCase(type)}
                Name={handleName()}
                type={handleName(type)}
                handleAdd={handleAdd}
                loading={loading}
                cancelUrl={handleNavigation()}
                existingName={existingName}
                setExistingName={setExistingName}
                toastErrorMessage={toastErrorMessage}
                setToastErrorMessage={setToastErrorMessage}
                existingItems={existingItems}
                existingItemsLoading={existingItemsLoading}
                insertEntityName={handleName()}
                insertType={insertType}
                setInsertType={setInsertType}
                afterItemId={afterItemId}
                setAfterItemId={setAfterItemId}
            />
        </>
    )
}
